module.exports = __webpack_public_path__ + "img/icon07.187e64ed.jpg";